"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _useButtonSettings2 = _interopRequireDefault(require("../../hooks/useButtonSettings"));

var _MenuGroup = _interopRequireDefault(require("./MenuGroup"));

require("./styles.less");

var styles = {
  "popover": "meepshop-meep-ui__submenu-dropdownMenu-styles__popover",
  "groupPopover": "meepshop-meep-ui__submenu-dropdownMenu-styles__groupPopover",
  "menu": "meepshop-meep-ui__submenu-dropdownMenu-styles__menu",
  "menuItem": "meepshop-meep-ui__submenu-dropdownMenu-styles__menuItem",
  "arrow": "meepshop-meep-ui__submenu-dropdownMenu-styles__arrow"
};

var MenuItem = function MenuItem(_ref) {
  var page = _ref.page,
      menuSettings = _ref.menuSettings,
      ContentComponent = _ref.ContentComponent;

  var _useButtonSettings = (0, _useButtonSettings2["default"])(page, {
    menuSettings: menuSettings
  }),
      title = _useButtonSettings.title,
      action = _useButtonSettings.action,
      isActive = _useButtonSettings.isActive,
      hasGroup = _useButtonSettings.hasGroup,
      url = _useButtonSettings.url,
      target = _useButtonSettings.target; // 有子選單


  if (hasGroup) {
    return /*#__PURE__*/_react["default"].createElement(_MenuGroup["default"], {
      page: page,
      menuSettings: menuSettings,
      ContentComponent: ContentComponent
    });
  } // 有 action, 取代 url


  if (action) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: styles.menuItem,
      style: {
        fontWeight: isActive ? 'bold' : 'normal',
        fontSize: menuSettings.submenuFontSize || 'var(--submenu-font-size)'
      },
      onClick: action,
      type: "button"
    }, title);
  } // 一般的連結


  return /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: url,
    target: target,
    passHref: true
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: url,
    target: target,
    className: styles.menuItem,
    style: {
      fontWeight: isActive ? 'bold' : 'normal',
      fontSize: menuSettings.submenuFontSize || 'var(--submenu-font-size)'
    }
  }, title));
};

var _default = MenuItem;
exports["default"] = _default;